module.exports = __webpack_public_path__ + "img/17.SMART-graphic-centennial.5494fae2.png";